// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronDown: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m21.492 7.878-9.307 9.308-9.308-9.308L3.94 6.814l8.245 8.244 8.244-8.244 1.064 1.064Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ChevronDownOffset: IconOffset = {
    vertical: 28, // Store Custom Code
    horizontal: 10, // Store Custom Code
};

export default React.memo(ChevronDown);
